import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import useIsSmartphone from './useIsSmartphone';
import useIsTablet from './useIsTablet';
import lastfall1 from '../images/lastfall-1.png';
import lastfall2 from '../images/lastfall-2.png';
import lastfall3 from '../images/lastfall-3.png';

// Styles
const commonStyles = css`
  font-family: Arial, sans-serif;
  font-size: 2.2rem;
  font-weight: 400;
`;

const Container = styled.div`
  @media (min-width: 769px) {
    background-color: ${props => props.bgColor || 'white'};
    
    padding: 20px;
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    background-color: ${props => props.bgColor || 'white'};
    
    padding: 10px;
    box-sizing: border-box;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Section = styled.div`
  @media (min-width: 769px) {
    
  }

  @media (max-width: 768px) {
    
  }
`;

const SectionTitle = styled.div`
  font-size: 2.2rem;
  font-weight: 400;
  color: ${props => props.color || '#0078c9'};
  margin-top: ${props => props.marginTop || '0'};
  text-transform: uppercase;
`;

const SubTitle = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  color: gray;
  margin-top: -1px;
`;

const DataDisplay = styled.div`
  @media (min-width: 769px) {
    display: flex;
    font-size: 2.2rem;
    font-weight: 600;
    color: black;
    margin-top: 5px;
    

    p {
      margin: 0;
    }
  }

  @media (max-width: 768px) {
    display: flex;
    font-size: 2.2rem;
    font-weight: 600;
    color: black;
    margin-top: 5px;
    

    p {
      margin: 0;
    }
  }
`;

const DataUnit = styled.div`
  @media (min-width: 769px) {
    margin-top: 9.5px;
    margin-left: 5px;
    font-size: 1.4rem;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    margin-top: 8px;
    margin-left: 5px;
    font-size: 1.4rem;
    font-weight: 600;
  }
`;

const DataUnit2 = styled.div`
  @media (min-width: 769px) {
    margin-top: 15px;
    font-size: 1rem;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    margin-top: 12.5px;
    font-size: 1rem;
    font-weight: 600;
  }
`;

const DataUnit3 = styled.div`
  margin-top: 1px;
  margin-left: 5px;
  font-size: 2.2rem;
  font-weight: 600;
`;


const Description = styled.div`
  @media (min-width: 769px) {
    font-size: 1.4rem;
    font-weight: 600;
    color: gray;
    margin-top: -2px;
    
  }

  @media (max-width: 768px) {
    font-size: 1.4rem;
    font-weight: 600;
    color: gray;
    margin-top: -2px;
    
  }
`;

const ImageContainer = styled.div`
  margin-top: ${props => props.marginTop || '50px'};
  margin-left: 20px;
  margin-right: 0px;
`;

const StyledImage = styled.img`
  height: auto;
`;

// Component
const C1Result = ({ bgColor, 
  sLf1Dia, sLf1Surface,
  sLf2Dia, sLf2Surface,
  sLf3Dia, sLf3Surface
 }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;

  const isSmartphone = useIsSmartphone();
  const isTablet = useIsTablet();
  let w1;
  let w2;
  let w3;
  let mt1;
  let mt2;
  let mt3;

  if (isSmartphone) { w1 = '45px'; w2 = '80px'; w3 = '80px'; mt1 = '70px'; mt2 = '155px'; mt3 = '145px'; }
  else if (isTablet) { w1 = '65px'; w2 = '115px'; w3 = '110px'; mt1 = '40px'; mt2 = '115px'; mt3 = '115px'; }
  else { w1 = '70px'; w2 = '120px'; w3 = '120px'; mt1 = '25px'; mt2 = '120px'; mt3 = '100px'; }

  let m1Left;
  if (isSmartphone) { m1Left = '3.5%'; }
  else if (isTablet) { m1Left = '5.2%'; }
  else { m1Left = '20px'; }

  let m2Left;
  if (isSmartphone) { m2Left = '20px'; }
  else if (isTablet) { m2Left = '70px'; }
  else { m2Left = '40px'; }

  let w1wid;
  if (isSmartphone) { w1wid = '100%'; }
  else if (isTablet) { w1wid = '100%'; }
  else { w1wid = '410px'; }

  let m1LeftImg;
  if (isSmartphone) { m1LeftImg = '-35px'; }
  else if (isTablet) { m1LeftImg = '60px'; }
  else { m1LeftImg = '0px'; }

  let m2LeftImg;
  if (isSmartphone) { m2LeftImg = '-75px'; }
  else if (isTablet) { m2LeftImg = '35px'; }
  else { m2LeftImg = '-55px'; }

  let m3LeftImg;
  if (isSmartphone) { m3LeftImg = '-45px'; }
  else if (isTablet) { m3LeftImg = '45px'; }
  else { m3LeftImg = '-20px'; }

  return (
    <Container style={{ width: '100%'  }} bgColor={bgColor}>
      <Section style={{ marginLeft: m1Left }}>
        <div style={{ display: 'flex', width: w1wid }}>
          <div style={{ textAlign: 'left' }}>

            {/* Lift and put down */}
            <div style={{ display: 'flex' }}>

              <div>

                <SectionTitle color="#0078c9" marginTop="15px">{t('Lift and put down')}</SectionTitle>
                <SubTitle>{t('Load case 1 - Horizontal force application')}</SubTitle>
                <DataDisplay style={{ marginLeft: m2Left }}>
                  <DataUnit2>{'>'}</DataUnit2>
                  <DataUnit3>{sLf1Dia}</DataUnit3>
                  <DataUnit>{'mm'}</DataUnit>
                </DataDisplay>
                <Description style={{ marginLeft: m2Left }}>{t('Required suction cup diameter')}</Description>
                <DataDisplay style={{ marginLeft: m2Left }}>
                  <DataUnit2>{'>'}</DataUnit2>
                  <DataUnit3>{sLf1Surface}</DataUnit3>
                  <DataUnit>{'mm²'}</DataUnit>
                </DataDisplay>
                <Description style={{ marginLeft: m2Left }}>{t('Required suction surface')}</Description>

              </div>

              <div style={{ marginLeft: m1LeftImg }}>

                <ImageContainer marginTop={mt1}>
                  <StyledImage src={lastfall1} alt='lastfall1' width={w1} />
                </ImageContainer>
               
              </div>

            </div>

            {/* Lift and move */}
            <div style={{ display: 'flex' }}>

              <div>

                <SectionTitle color="#087ccc" marginTop="60px">{t('Lift and move')}</SectionTitle>
                <SubTitle>{t('Load case 2 - Horizontal force application')}</SubTitle>
                <DataDisplay style={{ marginLeft: m2Left }}>
                  <DataUnit2>{'>'}</DataUnit2>
                  <DataUnit3>{sLf2Dia}</DataUnit3>
                  <DataUnit>{'mm'}</DataUnit>
                </DataDisplay>
                <Description style={{ marginLeft: m2Left }}>{t('Required suction cup diameter')}</Description>
                <DataDisplay style={{ marginLeft: m2Left }}>
                  <DataUnit2>{'>'}</DataUnit2>
                  <DataUnit3>{sLf2Surface}</DataUnit3>
                  <DataUnit>{'mm²'}</DataUnit>
                </DataDisplay>
                <Description style={{ marginLeft: m2Left }}>{t('Required suction surface')}</Description>

              </div>

              <div style={{ marginLeft: m2LeftImg }}>

                <ImageContainer marginTop={mt2}>
                  <StyledImage src={lastfall2} alt='lastfall2' width={w2} />
                </ImageContainer>
                
              </div>

            </div>

            {/* Lift and rotate */}
            <div style={{ display: 'flex' }}>

              <div>

                <SectionTitle color="#087ccc" marginTop="60px">{t('Lift and rotate')}</SectionTitle>
                <SubTitle>{t('Load case 3 - Vertical force application')}</SubTitle>
                <DataDisplay style={{ marginLeft: m2Left }}>
                  <DataUnit2>{'>'}</DataUnit2>
                  <DataUnit3>{sLf3Dia}</DataUnit3>
                  <DataUnit>{'mm'}</DataUnit>
                </DataDisplay>
                <Description style={{ marginLeft: m2Left }}>{t('Required suction cup diameter')}</Description>
                <DataDisplay style={{ marginLeft: m2Left }}>
                  <DataUnit2>{'>'}</DataUnit2>
                  <DataUnit3>{sLf3Surface}</DataUnit3>
                  <DataUnit>{'mm²'}</DataUnit>
                </DataDisplay>
                <Description style={{ marginLeft: m2Left }}>{t('Required suction surface')}</Description>

              </div>

              <div style={{ marginLeft: m3LeftImg }}>

                <ImageContainer marginTop={mt3}>
                  <StyledImage src={lastfall3} alt='lastfall3' width={w3} />
                </ImageContainer>
                
              </div>

            </div>





            {(isSmartphone || isTablet) && (
              <div>
                <br></br>
                <br></br>
                <br></br>
              </div>
            )}





          </div>
        </div>
      </Section>
    </Container>
  );
};

export default C1Result;
